export const LICENSE_INACTIVE_MESSAGE = '라이선스가 비활성화되어 요청을 처리할 수 없습니다. 조직 관리자에게 라이선스 활성화를 요청해 주세요.'

export function isLicenseInactiveResponse(response) {
  return Boolean(
    response
    && response.status === 429
    && String(response.data?.err_code) === '1001175'
    && response.data?.err_msg === 'license_active'
  )
}

export function handleLicenseInactiveError(store, error) {
  if (!isLicenseInactiveResponse(error?.response)) return false
  store.commit('swalToast', {
    title: LICENSE_INACTIVE_MESSAGE,
    type: 'warning',
  })
  return true
}
